module.exports = __webpack_public_path__ + "img/1.032ea182.png";